export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const BASE_URL_v2 = process.env.REACT_APP_API_BASE_URL_v2;
export const BASE_URL_v3 = process.env.REACT_APP_API_BASE_URL_v3;

export const CONFERENCE_URL = `${BASE_URL}/conferences`;
export const SCHOOL_URL = `${BASE_URL}/schools`;
export const SCHOOL_URL_V2 = `${BASE_URL_v2}/schools`;
export const TEAMS_URL = `${BASE_URL}/teams`;
export const STAFF_MEMBERS_URL = `${BASE_URL}/staff_members`;
export const STAFF_MEMBERS_URL_V2 = `${BASE_URL_v2}/staff_members`;
export const BACKGROUND_OPERATIONS_V2 = `${BASE_URL_v2}/background-operations`;
export const STAFF_TYPES_URL = `${BASE_URL}/staff_types`;
export const USERS_URL = `${BASE_URL}/users`;
export const GOALS_URL = `${BASE_URL}/goals`;
export const FEELINGS_URL = `${BASE_URL}/feelings`;
export const STUDENTS_URL = `${BASE_URL}/students`;
export const STUDENTS_URL_V2 = `${BASE_URL_v2}/students`;
export const SPORTS_URL = `${BASE_URL}/sports`;
export const MASTER_SPORTS_URL = `${BASE_URL_v3}/sports`;
export const RECONCILIATION_TEAMS_URL = `${BASE_URL_v3}/reconciliation/teams`;
export const CROSS_ORG_SPORT_REPORT_URL = `${BASE_URL_v3}/reports/sport`;
export const APPOINTMENT_URL = `${BASE_URL}/appointments`;
export const EVENT_URL = `${BASE_URL}/events`;
export const ALUMNI_URL = `${BASE_URL}/alumni`;
export const DAILY_PICKS_URL = `${BASE_URL}/content_rules`;
export const CONTENT_AUTHORS_URL = `${BASE_URL}/content_authors`;
export const CONTENTS_URL = `${BASE_URL}/contents`;
export const CONTENTS_URL_v2 = `${BASE_URL_v2}/library`;

export const MOODS_URL = `${BASE_URL}/moods`;
export const SUBMOODS_URL = `${BASE_URL_v2}/submoods`;
export const UNIVERSITY_HUB_URL = `${BASE_URL_v2}/university_hub`;
export const FOCUS_URL = `${BASE_URL_v2}/focus-areas`;
export const LIBRARY_URL = `${BASE_URL_v2}/library`;
export const DASHBOARD_URL = `${BASE_URL_v2}/dashboard`;
export const POLLS_URL = `${BASE_URL_v2}/polls`;
export const TELEHELP_TOPICS_URL = `${BASE_URL_v2}/telehelp-topics`;
export const ZONE_IN_URL = `${BASE_URL_v2}/zonein_contents`;
export const SCHEDULED_NOTIFICATION = `${BASE_URL_v2}/scheduled_notification`;
export const TAGS_URL = `${BASE_URL_v2}/tags`;
export const SUBFACTORS_URL = `${BASE_URL_v2}/subfactors`;
export const CONTRIBUTING_FACTORS = `${BASE_URL_v2}/contributing-factors`;
export const PERMISSION = `${BASE_URL_v2}/permissions`;

export const CATEGORIES = `${BASE_URL_v2}/categories/all`;

export const SPOTLIGHTS = `${BASE_URL_v3}/spotlights`;
export const PLAYLISTS = `${BASE_URL_v3}/playlists`;
export const WEEKLY_REPORTS = `${BASE_URL_v3}/weekly_reports`;

// TZ-789 two-file roster upload
export const ONBOARDING_STAFF_URL    = `${BASE_URL_v3}/onboarding/staff`;
export const ONBOARDING_STUDENTS_URL = `${BASE_URL_v3}/onboarding/students`;

// TZ-786 Step 5 activation tracking
// School-level stats endpoint is parameterized by school_id; the
// per-team named list endpoint is parameterized by team_id. The CRUD
// wrappers append the id at call time so the constants stay base-only.
export const SCHOOL_ACTIVATION_STATS_URL = (schoolId) =>
  `${BASE_URL_v3}/schools/${schoolId}/activation_stats`;
export const TEAM_INACTIVE_STUDENTS_URL = (teamId) =>
  `${BASE_URL_v3}/teams/${teamId}/inactive_students`;
